import { Box, BoxProps, Typography, useTheme } from '@mui/material'
import React, { FC } from 'react'

export const SectionHeader: FC<{ children: React.ReactNode } & BoxProps> = ({ children, ...props }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        height: '34px',
        backgroundColor: theme.palette.background.subtle,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0px',
        gap: '8px',
        paddingLeft: '16px',
        justifyContent: 'center',
        borderRadius: 1,
        marginBottom: 2,
      }}
      {...props}
    >
      <Typography variant={'captionBold'}>{children}</Typography>
    </Box>
  )
}
